import styled from "styled-components";
import PropTypes from "prop-types";

import { colors } from "./colors";
import { default as fonts } from "./fonts";
import { bold as boldStyles } from "./fontStyles";

const FormFieldError = styled.span`
    color: ${colors.coral};
    ${({ size }) => fonts.typeScale[size]}
    ${({ bold }) => (bold ? boldStyles : null)}
`;

FormFieldError.propTypes = {
    size: PropTypes.number,
    bold: PropTypes.bool
};

export { FormFieldError };
